<template>
  <div class="otpusks">
    <div class="otpusks-header">
      <section class="outpusk-name">
        <h2>Справка отпуски</h2>
        <label class="checkbox-wrapper">
          Виж общ брой дни
          <input type="checkbox" v-model="onlyCount" />
          <span class="checkmark"></span>
        </label>
      </section>

      <div class="header-controlls" ref="top">
        <div class="datepicker">
          <div class="new-input-wrapper">
            <div class="new-input">
              <span class="miv">D</span>
              <input
                type="text"
                placeholder="От дата"
                @click="openDropdown(0)"
                @focus="openDropdown(0)"
                @blur="closeDropdown(0)"
                v-model="formatedFromDate"
                readonly
              />
            </div>
          </div>
          <div class="new-input-wrapper">
            <div class="new-input">
              <span class="miv">D</span>
              <input
                type="text"
                placeholder="До дата"
                @click="openDropdown(1)"
                @focus="openDropdown(1)"
                @blur="closeDropdown(1)"
                v-model="formatedToDate"
                readonly
              />
            </div>
          </div>
          <div
            class="new-input-dropdown datepicker-dropdown"
            :class="{ 'datepicker-dropdown-active' : openedDropdown[0] }"
          >
            <datepicker
              :language="bg"
              :inline="true"
              :monday-first="true"
              :wrapper-class="'custom-datepicker'"
              :calendar-class="'custom-calendar'"
              v-model="fromDate"
              @selected="closeDropdown(0)"
            ></datepicker>
          </div>
          <div
            class="new-input-dropdown datepicker-dropdown"
            :class="{ 'datepicker-dropdown-active' : openedDropdown[1] }"
          >
            <datepicker
              :language="bg"
              :inline="true"
              :monday-first="true"
              :wrapper-class="'custom-datepicker'"
              :calendar-class="'custom-calendar'"
              v-model="toDate"
              @selected="closeDropdown(1)"
            ></datepicker>
          </div>
        </div>
        <!-- DESKTOP BUTTONS -->
        <div class="btns desktop">
          <router-link to="/users" class="btn btn-close">
            <span class="miv">F</span>
            Затвори справка
          </router-link>
          <button class="btn btn-excel" @click="exportToExcelFile()">
            <span class="miv">E</span>
            Експорт в Excel
          </button>
        </div>
      </div>
    </div>
    <div class="table-wrapper">
      <table v-if="otpusks.length" class="table" ref="otpusksTable">
        <thead>
          <tr>
            <th>
              <span>Име</span>
            </th>
            <th>
              <span>Платен отпуск</span>
            </th>
            <th>
              <span>Неплатен отпуск</span>
            </th>
            <th>
              <span>Болничен</span>
            </th>
            <th>
              <span>Неприсъствен</span>
            </th>
            <th>
              <span>Командировка с преспиване</span>
            </th>
            <th>
              <span>Командировка без преспиване</span>
            </th>
            <!-- <th>
              <span>Фиктивен</span>
            </th> -->
          </tr>
        </thead>
        <tbody v-if="otpusks.length">
          <tr v-for="(o, i) in otpusks" :key="`otpusks-${i}`">
            <td>
              <span>
                <!-- <span class="miv">B</span> -->
                {{ o._id.name }}
              </span>
            </td>
            <td>
              <div class="otpusks-list list-paid">
                <span v-if="onlyCount"><strong>{{ o.total.paid || 0 }}</strong></span>
                <template v-else>
                  <p
                  v-for="(p, j) in o.paid"
                  :key="`otpusk-${i}-paid-${j}`"
                  ><strong>({{p.days}})</strong> {{ p.dateFrom | formatDate }} - {{ p.dateTo | formatDate }}&nbsp;</p>
                  <p v-if="!o.paid"><strong>(-)</strong></p>
                </template>
              </div>
            </td>
            <td>
              <div class="otpusks-list list-unpaid">
                <span v-if="onlyCount"><strong>{{ o.total.unpaid || 0 }}</strong></span>
                <template v-else>
                  <p
                  v-for="(u, j) in o.unpaid"
                  :key="`otpusk-${i}-unpaid-${j}`"
                  ><strong>({{u.days}})</strong>  {{ u.dateFrom | formatDate }} - {{ u.dateTo | formatDate }}&nbsp;</p>
                  <p v-if="!o.unpaid"><strong>(-)</strong></p>
                </template>
              </div>
            </td>
            <td>
              <div class="otpusks-list list-hospital">
                <span v-if="onlyCount"><strong>{{ o.total.hospital || 0 }}</strong></span>
                <template v-else>
                <p
                  v-for="(h, j) in o.hospital"
                  :key="`otpusk-${i}-hospital-${j}`"
                ><strong>({{h.days}})</strong>  {{ h.dateFrom | formatDate }} - {{ h.dateTo | formatDate }}&nbsp;</p>
                <p v-if="!o.hospital"><strong>(-)</strong></p>
              </template>
              </div>
            </td>
            <td>
              <div class="otpusks-list list-notpresent">
                <span v-if="onlyCount"><strong>{{ o.total.notpresent || 0 }}</strong></span>
                <template v-else>
                <p
                  v-for="(h, j) in o.notpresent"
                  :key="`otpusk-${i}-notpresent-${j}`"
                ><strong>({{h.days}})</strong>  {{ h.dateFrom | formatDate }} - {{ h.dateTo | formatDate }}&nbsp;</p>
                <p v-if="!o.notpresent"><strong>(-)</strong></p>
              </template>
              </div>
            </td>
            <td>
              <div class="otpusks-list list-tripovernight">
                <span v-if="onlyCount"><strong>{{ o.total.tripovernight || 0 }}</strong></span>
                <template v-else>
                <p
                  v-for="(h, j) in o.tripovernight"
                  :key="`otpusk-${i}-tripovernight-${j}`"
                ><strong>({{h.days}})</strong>  {{ h.dateFrom | formatDate }} - {{ h.dateTo | formatDate }}&nbsp;</p>
                <p v-if="!o.tripovernight"><strong>(-)</strong></p>
              </template>
              </div>
            </td>
            <td>
              <div class="otpusks-list list-tripday">
                <span v-if="onlyCount"><strong>{{ o.total.tripday || 0 }}</strong></span>
                <template v-else>
                <p
                  v-for="(h, j) in o.tripday"
                  :key="`otpusk-${i}-tripday-${j}`"
                ><strong>({{h.days}})</strong>  {{ h.dateFrom | formatDate }} - {{ h.dateTo | formatDate }}&nbsp;</p>
                <p v-if="!o.tripday"><strong>(-)</strong></p>
              </template>
              </div>
            </td>
            <!-- <td>
              <div class="otpusks-list list-fake">
                <span v-if="onlyCount"><strong>{{ o.total.fake || 0 }}</strong></span>
                <template v-else>
                <p
                  v-for="(h, j) in o.fake"
                  :key="`otpusk-${i}-fake-${j}`"
                ><strong>({{h.days}})</strong>  {{ h.dateFrom | formatDate }} - {{ h.dateTo | formatDate }}&nbsp;</p>
                <p v-if="!o.fake"><strong>(-)</strong></p>
              </template>
              </div>
            </td> -->
          </tr>
        </tbody>
      </table>
    </div>
    <!-- MOBILE BUTTONS -->
    <footer class="modal-footer mobile" ref="footer">
      <div class="btns mobile">
        <!-- EXPORT IN EXCEL -->
        <!-- <span class="new-content-data-item-toggle-circle mobile excel" @click="exportToExcelFile()">
          <span class="miv">E</span>
        </span> -->
      </div>
    </footer>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { bg } from 'vuejs-datepicker/dist/locale';
import { format } from "date-fns";
import * as XLSX from 'xlsx';
import holidays from './mixins/holidays';
export default {
  mixins: [holidays],
  components: {
    Datepicker
  },
  data() {
    return {
      bg: bg,
      openedDropdown: [false, false],
      fromDate: undefined,
      toDate: undefined,
      formatedFromDate: undefined,
      formatedToDate: undefined,
      onlyCount: false,
      otpusks: []
    };
  },
  watch: {
    fromDate(to, from) {
      this.fromDate.setHours(0, 0, 0, 0);
      this.formatedFromDate = format(new Date(this.fromDate), 'dd/MM/yyyy')
      // eslint-disable-next-line
      if (!!from) {
        this.getOtpusks();
      }
    },
    toDate(to, from) {
      this.toDate.setHours(23, 59, 59, 999);
      this.formatedToDate = format(new Date(this.toDate), 'dd/MM/yyyy')
      // eslint-disable-next-line
      if (!!from) {
        this.getOtpusks();
      }
    }
  },
  methods: {
    // Open dropdown. Depends on index (hard coded in template)
    openDropdown(i) {
      this.$set(this.openedDropdown, i, true);
    },
    // Close dropdown. Depends on index (hard coded in template)
    closeDropdown(i) {
      setTimeout(() => {
        this.$set(this.openedDropdown, i, false);
      }, 100);
    },
    setDates() {
      const date = new Date();
      // set first day of previous month
      this.fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
      this.fromDate.setHours(0, 0, 0, 0);
      // set last day of previous month
      this.toDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.toDate.setHours(23, 59, 59, 999);
    },
    getOtpusks() {
      this.$store.dispatch('startLoading');
      let url = `${
        process.env.VUE_APP_BASE_URI
      }/otpusk?from=${this.fromDate.toISOString()}&to=${this.toDate.toISOString()}&group=true&count=${this.onlyCount}`;
      this.$http
        .get(url)
        .then((response) => {
          this.otpusks = response.data;
          this.otpusks.forEach((otp) => {
            let total = { paid: 0, unpaid: 0, hospital: 0, fake: 0, notpresent: 0, tripovernight: 0, tripday: 0 };

            ["paid", "unpaid", "hospital", "fake", "notpresent", "tripovernight", "tripday"].forEach((type) => {
              if (otp[type] && otp[type].length > 0) {
                otp[type] = otp[type].map((p) => {
                  let days = this.calculateHolidays(p.dateFrom, p.dateTo);
                  total[type] += days;
                  return { ...p, days };
                });
              }
            });

            otp.total = total;
          });
          this.$store.dispatch("stopLoading");
        })
        .catch(error => console.log(error));
    },
    exportToExcelFile() {
      if(!this.otpusks.length) {
        return this.$snotify.error('Няма отпуски за експорт')
      }
      const wscols = [{ wpx: 200 }, { wpx: 200 }, { wpx: 200 }, { wpx: 200 }, { wpx: 200 }, { wpx: 200 }, { wpx: 200 }];

      const config = { dateNF: 'dd/mm/yyyy' };

      // Convert Table to Worksheet
      const workersWorksheet = XLSX.utils.table_to_sheet(
        this.$refs['otpusksTable'],
        config
      );
      // Define New Workbook
      const new_workbook = XLSX.utils.book_new();

      workersWorksheet['!cols'] = wscols;

      // Append Worksheet
      XLSX.utils.book_append_sheet(
        new_workbook,
        workersWorksheet,
        'Справка отпуски'
      );
      // Save File

      XLSX.writeFile(
        new_workbook,
        `Справка-отпуски-${this.formatedFromDate}-${this.formatedToDate}.xlsx`
      );
    }
  },
  mounted() {
    this.setDates();
    this.getOtpusks();
  }
};
</script>

<style scoped>
.otpusks {
  background-color: #f0f7f7;
  min-height: calc(100vh - 100px);
  padding: 10px 40px;
}
.otpusks-header {
  align-items: center;
  display: flex;
  height: 36px;
  justify-content: space-between;
}
.outpusk-name {
  align-items: center;
  display: flex;
  gap: 10px;
}
.header-controlls {
  align-items: center;
  display: flex;
}
.pre-datepicker-text {
  color: #373737;
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  margin-right: 20px;
}
.datepicker {
  border-radius: 4px;
  display: flex;
  position: relative;
  width: 330px;
  padding: 10px 0;
}
.datepicker .new-input-wrapper {
  background-color: #c9d9d9;
  margin: 0;
  width: 50%;
}
.datepicker .new-input-wrapper:first-child {
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}
.datepicker .new-input-wrapper:nth-child(2) {
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}
.datepicker .new-input {
  background-color: transparent;
  margin: 0;
}
.datepicker .new-input input {
  background-color: transparent;
  border: 1px solid #c9d9d9;
  height: 36px;
  cursor: pointer;
}
.datepicker .new-input input:focus {
  background-color: #f4f4f4;
  border: 1px solid #0099ff;
}
.datepicker .datepicker-dropdown {
  /* background-color: #ccd1e3; */
}
.table-wrapper {
  overflow: auto;
}
.table {
  height: 1px;
}
.table thead th {
  background-color: #c9d9d9;
}
.table tr {
  height: initial;
}
.table th,
.table td {
  padding: 10px;
  vertical-align: top;
}
.table tr td:first-child,
.table tr th:first-child {
  width: 100%;
}
.table th > span,
.table td > span {
  align-items: center;
  display: inline-flex;
  min-height: 30px;
  white-space: nowrap;
}
td .miv {
  padding: 0 7px 0 4px;
}
.otpusks-list {
  background-color: #f3f3f3;
  border-radius: 4px;
  height: 100%;
  min-width: 200px;
  padding: 10px 15px;
}
.otpusks-list p {
  display: flex;
  justify-content: space-between;
  white-space: nowrap;
  width: 100%;
}
.otpusks-list p strong {
  display: inline-block;
  padding-right: 15px;
}
.list-paid {
  background-color: #e6f3e6;
}
.list-unpaid {
  background-color: #f3eae6;
}
.list-hospital {
  background-color: #e6ecf3;
}
.list-fake {
  background-color: #f3e99a;
}
.list-notpresent {
  background-color: #e3e3e3;
}
.list-tripovernight,
.list-tripday {
  background-color: #cfe2f3;
}
.desktop {
  display: flex;
}
.mobile {
  display: none;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .mobile {
    display: flex;
  }
  .table-wrapper {
    overflow: auto;
  }
  .otpusks {
    padding: 10px 15px;
  }
  .otpusks-header h2,
  .otpusks-header .btn {
    display: none;
  }
  .otpusks-header {
    justify-content: flex-end;
  }
  .new-content-data-item-toggle-circle {
    height: 50px;
    width: 50px;
  }
  .new-content-data-item-toggle-circle.mobile {
    bottom: 20px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .new-content-data-item-toggle-circle.mobile.excel {
    background-color: green;
    bottom: 25px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .new-content-data-item-toggle-circle.mobile.top {
    background-color: #083f75;
    margin-top: 50px;
    position: inherit;
  }
  .new-content-data-item-toggle-circle .miv {
    border: 0px;
    font-size: 20px;
  }
  .modal-footer {
    background-color: #f0f0f7;
    height: 0;
    padding: 0px;
  }
}
@media screen and (max-width: 600px) {
  .datepicker {
    width: 100%;
  }
}
</style>
